import { achievements } from '../data/achievements';

export default function AchievementsWikiPage() {
    return (
        <div style={{ padding: '24px', maxWidth: '900px' }}>
            <h2 style={{ margin: '0 0 8px', fontSize: '22px', fontWeight: '700', color: 'var(--text-main)' }}>
                📖 Wiki des hauts faits
            </h2>
            <p style={{ margin: '0 0 24px', fontSize: '14px', color: 'var(--text-muted)' }}>
                Vue admin — toutes les conditions de déblocage, visibles en clair
            </p>

            <div style={{
                backgroundColor: 'var(--card-bg)',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
            }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                    <tr style={{ backgroundColor: 'var(--card-bg-secondary)' }}>
                        <th style={thStyle}></th>
                        <th style={thStyle}>Titre</th>
                        <th style={thStyle}>Code</th>
                        <th style={thStyle}>Condition</th>
                    </tr>
                    </thead>
                    <tbody>
                    {achievements.map(a => (
                        <tr key={a.code} style={{ borderTop: '1px solid var(--border-light)' }}>
                            <td style={{ ...tdStyle, fontSize: '20px' }}>{a.icon}</td>
                            <td style={{ ...tdStyle, fontWeight: '600', color: 'var(--text-main)' }}>{a.title}</td>
                            <td style={{ ...tdStyle, fontFamily: 'monospace', fontSize: '12px', color: 'var(--accent-color)' }}>{a.code}</td>
                            <td style={tdStyle}>{a.description}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const thStyle = { padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: 'var(--text-muted)' };
const tdStyle = { padding: '12px 16px', fontSize: '14px', color: 'var(--text-main)' };